import "./App.css";
import Footer from "./Components/Footer";
import Header from "./Components/Header";

import Navbar from "./Components/Home/Navbar";

import AllRoutes from "./Components/AllRoutes";

function App() {
     return (
          <>
               <Navbar />
               <Header />
               <AllRoutes />
               <Footer />
               <h1>hello</h1>
          </>
     );
}

export default App;
